"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PureSubscriptionSwitchesList = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _reactI18next = require("react-i18next");
var _CurrentPlanStyled = require("../CurrentPlan/CurrentPlanStyled");
var _SubscriptionManagementStyled = require("../SubscriptionManagement/SubscriptionManagementStyled");
var _OfferSwitchCard = _interopRequireDefault(require("../OfferSwitchCard"));
var _OfferSwitchCardLoader = _interopRequireDefault(require("../OfferSwitchCard/OfferSwitchCardLoader"));
var _MyAccountError = _interopRequireDefault(require("../MyAccountError"));
var _innerPopupReducer = require("../../redux/innerPopupReducer");
var _popupSlice = require("../../redux/popupSlice");
var _eventDispatcher = _interopRequireWildcard(require("../../util/eventDispatcher"));
var _SubscriptionSwitchesListStyled = require("./SubscriptionSwitchesListStyled");
var _helper = _interopRequireDefault(require("./helper"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable no-nested-ternary */
var selectPlanIcon = function selectPlanIcon(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      transform: "translate(-613.786 -616.883)",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
        fill: "none",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          d: "M636 630h41a3 3 0 0 1 3 3v38a3 3 0 0 1-3 3h-41a3 3 0 0 1-3-3v-38a3 3 0 0 1 3-3Z"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          d: "M636 632c-.551 0-1 .449-1 1v38c0 .551.449 1 1 1h41c.551 0 1-.449 1-1v-38c0-.551-.449-1-1-1h-41m0-2h41a3 3 0 0 1 3 3v38a3 3 0 0 1-3 3h-41a3 3 0 0 1-3-3v-38a3 3 0 0 1 3-3Z",
          fill: "#bcc3cd"
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "m682.711 618.297 8.492 8.492a2 2 0 0 1 0 2.828l-4.243 4.243-11.32-11.32 4.243-4.243a2 2 0 0 1 2.828 0Z",
        fill: "#bcc3cd"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "m643.724 666.06 3.776-15.09 11.314 11.313Z",
        fill: "#bcc3cd"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        fill: "#f8fafd",
        d: "m672.741 621.667 15.093 15.093-25.47 25.47-15.092-15.094z"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        fill: "#bcc3cd",
        d: "m674.627 623.553 11.32 11.32-25.47 25.47-11.32-11.32z"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          d: "M695.648 642.626h-1.572a.762.762 0 0 1-.762-.762.762.762 0 0 1 .762-.762h1.572a.762.762 0 0 1 .762.762.762.762 0 0 1-.762.762Z",
          fill: "#bcc3cd"
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          d: "M701.956 642.626h-1.572a.762.762 0 0 1-.762-.762.762.762 0 0 1 .762-.762h1.572a.762.762 0 0 1 .762.762.762.762 0 0 1-.762.762Z",
          fill: "#bcc3cd"
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          d: "M698.016 640.258a.761.761 0 0 1-.762-.762v-1.572a.761.761 0 0 1 .762-.762.762.762 0 0 1 .762.762v1.572a.762.762 0 0 1-.762.762Z",
          fill: "#bcc3cd"
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          d: "M698.016 646.567a.761.761 0 0 1-.762-.762v-1.572a.761.761 0 0 1 .762-.762.762.762 0 0 1 .762.762v1.572a.762.762 0 0 1-.762.762Z",
          fill: "#bcc3cd"
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          d: "m615.437 668.612-1.111-1.112a.762.762 0 0 1 0-1.078.762.762 0 0 1 1.077 0l1.112 1.112a.762.762 0 0 1 0 1.078.762.762 0 0 1-1.078 0Z",
          fill: "#bcc3cd"
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          d: "m619.898 673.072-1.111-1.112a.762.762 0 0 1 0-1.078.762.762 0 0 1 1.077 0l1.112 1.112a.762.762 0 0 1 0 1.078.762.762 0 0 1-1.078 0Z",
          fill: "#bcc3cd"
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          d: "M618.785 668.612a.762.762 0 0 1 0-1.077l1.111-1.112a.762.762 0 0 1 1.078 0 .762.762 0 0 1 0 1.078l-1.111 1.111a.762.762 0 0 1-1.078 0Z",
          fill: "#bcc3cd"
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          d: "M614.324 673.072a.762.762 0 0 1 0-1.077l1.111-1.112a.762.762 0 0 1 1.078 0 .762.762 0 0 1 0 1.078l-1.111 1.111a.762.762 0 0 1-1.078 0Z",
          fill: "#bcc3cd"
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M626.471 619a3 3 0 1 1-3 3 3 3 0 0 1 3-3Z",
        fill: "#bcc3cd"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
        cx: "3",
        cy: "3",
        r: "3",
        transform: "translate(688.471 681)",
        fill: "#bcc3cd"
      })]
    })
  });
};
selectPlanIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "88.932",
  height: "70.117"
};
const SubscriptionSwitchesList = () => {
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const {
    data: switchDetails
  } = (0, _reactRedux.useSelector)(state => state.plan.switchDetails);
  const {
    pauseOffersIDs
  } = (0, _reactRedux.useSelector)(state => state.offers);
  const {
    offerToSwitch
  } = (0, _reactRedux.useSelector)(state => state.plan);
  const {
    data: allSwitchSettings,
    loading: isSwitchSettingsLoading,
    error: isAllSwitchSettingsError
  } = (0, _reactRedux.useSelector)(state => state.plan.switchSettings);
  const isOfferSelected = !!offerToSwitch.offerId;
  const switchSettings = allSwitchSettings[offerToSwitch === null || offerToSwitch === void 0 ? void 0 : offerToSwitch.offerId] || {};
  const fromOfferId = offerToSwitch === null || offerToSwitch === void 0 ? void 0 : offerToSwitch.offerId;
  const pendingSwtichesToOfferIdsArray = Object.keys(switchDetails).map(item => {
    return switchDetails[item].toOfferId;
  });
  const dispatch = (0, _reactRedux.useDispatch)();
  if (isSwitchSettingsLoading) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_CurrentPlanStyled.SubscriptionStyled, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_OfferSwitchCardLoader.default, {})
    });
  }
  if (isAllSwitchSettingsError !== null && isAllSwitchSettingsError !== void 0 && isAllSwitchSettingsError.length) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_MyAccountError.default, {
      generalError: true
    });
  }
  if (!isOfferSelected) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_MyAccountError.default, {
      icon: selectPlanIcon,
      title: t('subscription-switches-list.offer-not-selected', 'Click on the plan that you would like to switch from'),
      margin: "0 auto"
    });
  }
  const availableSorted = Array.isArray(switchSettings.available) ? [...switchSettings.available].sort((aOffer, bOffer) => bOffer.price - aOffer.price) : [];

  // Filter out the pause subscription
  const availableFiltered = availableSorted === null || availableSorted === void 0 ? void 0 : availableSorted.filter(offer => !pauseOffersIDs.includes(offer.toOfferId));
  const unavailableFiltered = Array.isArray(switchSettings.unavailable) ? switchSettings.unavailable.filter(offer => !pauseOffersIDs.includes(offer.toOfferId)) : [];
  const allSwitchesBlocked = switchSettings.unavailableReason;
  if (allSwitchesBlocked) {
    const error = _helper.default[allSwitchesBlocked.code] ? _helper.default[allSwitchesBlocked.code] : _helper.default.DEFAULT;
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_MyAccountError.default, {
      icon: error.icon,
      title: t(error.title.translationKey, error.title.text),
      subtitle: t(error.subtitle.translationKey, error.subtitle.text),
      margin: "0 auto",
      fullWidth: true
    });
  }
  if (!(availableFiltered !== null && availableFiltered !== void 0 && availableFiltered.length) && !(unavailableFiltered !== null && unavailableFiltered !== void 0 && unavailableFiltered.length)) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_MyAccountError.default, {
      icon: selectPlanIcon,
      title: t('subscription-switches-list.switching-unavailable', "Looks like there aren't any options for switching from your current plan right now"),
      margin: "0 auto"
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [!!availableFiltered.length && availableFiltered.map(subItem => {
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_CurrentPlanStyled.SubscriptionStyled, {
        as: "article",
        hide: pendingSwtichesToOfferIdsArray.find(item => item === subItem.toOfferId),
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_OfferSwitchCard.default, {
          baseOfferId: fromOfferId,
          toOfferId: subItem.toOfferId
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_SubscriptionSwitchesListStyled.ButtonWrapperStyled, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_SubscriptionManagementStyled.SimpleButtonStyled, {
            onClickFn: () => {
              (0, _eventDispatcher.default)(_eventDispatcher.MSSDK_SWITCH_BUTTON_CLICKED, {
                fromOfferId,
                toOfferId: subItem.toOfferId,
                switchDirection: subItem.switchDirection,
                algorithm: subItem.algorithm
              });
              dispatch((0, _popupSlice.showPopup)({
                type: _innerPopupReducer.POPUP_TYPES.switchPlan,
                data: {
                  offerData: {
                    ...subItem
                  }
                }
              }));
            },
            children: t("subscription-switches-list.".concat(subItem.switchDirection, "-button"), subItem.switchDirection)
          })
        })]
      }, subItem.toOfferId);
    }), !!unavailableFiltered.length && unavailableFiltered.map(subItem => {
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_CurrentPlanStyled.SubscriptionStyled, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_OfferSwitchCard.default, {
          baseOfferId: fromOfferId,
          toOfferId: subItem.toOfferId
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_SubscriptionSwitchesListStyled.ButtonWrapperStyled, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_SubscriptionManagementStyled.SimpleButtonStyled, {
            disabled: true,
            children: t("subscription-switches-list.".concat(subItem.switchDirection, "-button"), subItem.switchDirection)
          })
        })]
      }, subItem.toOfferId);
    })]
  });
};
exports.PureSubscriptionSwitchesList = SubscriptionSwitchesList;
var _default = exports.default = SubscriptionSwitchesList;